import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ScheduledTask\UpdateScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/UpdateScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
const UpdateScheduledTaskController = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateScheduledTaskController.url(args, options),
    method: 'put',
})

UpdateScheduledTaskController.definition = {
    methods: ["put"],
    url: '/api/scheduled-task/{scheduled_task}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ScheduledTask\UpdateScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/UpdateScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
UpdateScheduledTaskController.url = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { scheduled_task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { scheduled_task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            scheduled_task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        scheduled_task: typeof args.scheduled_task === 'object'
        ? args.scheduled_task.id
        : args.scheduled_task,
    }

    return UpdateScheduledTaskController.definition.url
            .replace('{scheduled_task}', parsedArgs.scheduled_task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\UpdateScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/UpdateScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
UpdateScheduledTaskController.put = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateScheduledTaskController.url(args, options),
    method: 'put',
})

export default UpdateScheduledTaskController